/**
 * The name to greet someone by: their first name, not their title.
 * "Dr Meera Rao" is greeted "Meera", not "Dr" (seen in the top bar,
 * 2026-09-22). Falls back to the whole name when there is nothing else.
 */
const TITLES = /^(dr|prof|professor|mr|mrs|ms|miss|mx|shri|sri|smt|kumari|er|adv)\.?$/i;

export default function greetingName(name) {
  const words = String(name || '').trim().split(/\s+/).filter(Boolean);
  const first = words.find((w) => !TITLES.test(w));
  return first || words[0] || '';
}
